import merge from 'lodash/merge';
import { TrackingData } from './TrackingData';

/** Owns a collection of analytics data fragments, and the means to build them into one big data
 * blob. Used to "mount" and "unmount" fragments of analytics data from different places in the
 * tree, and then combine them together for attachment onto analytics events.
 */
export class AnalyticsState {
  private storage = new Map<string, TrackingData>();

  /**
   * @param id — an arbitrary ID for this fragment.
   * @param data — a fragment of analytics data to contribute
   */
  addFragment = (id: string, data: TrackingData) => {
    this.storage.set(id, data);
  };

  /** @param id — the same id used when calling `addFragment()` */
  removeFragment = (id: string) => {
    this.storage.delete(id);
  };

  /** @returns a combination of all the analytics fragments merged together */
  build = () => {
    const built: TrackingData = {};
    this.storage.forEach(data => merge(built, data));
    return built;
  };
}
